import { Button, Col, Container, Row } from "react-bootstrap";

import { Notificacion } from "@components/general/Alertas/Alertas";
import React from "react";
import { deactivateLicencia } from "@helpers/httpRequests/httpRequestsLicencias/httpRequestsLicencias";

export const EliminarLicencia = ({ licencia, setLicenciaEliminada }) => {
  const handleEliminarLicencia = async () => {
    try {
      await deactivateLicencia(licencia.idLicencia);

      setLicenciaEliminada(true);

      Notificacion("success", "La licencia se eliminó correctamente");
    } catch (error) {
      console.log("Error al eliminar la licencia seleccionada: ", error);

      Notificacion(
        "error",
        "No se pudo eliminar la licencia, por favor vuelve a intentar."
      );
    }
  };

  const handleCancelar = () => {
    Notificacion("info", "La licencia no fue eliminada");
  };

  return (
    <Container fluid className="text-center">
      <h3>¿Estás seguro que deseas eliminar esta licencia?</h3>

      <Row className="pt-3">
        <Col>
          <Button variant="success" onClick={handleEliminarLicencia}>
            Sí, eliminar
          </Button>
        </Col>

        <Col>
          <Button variant="danger" onClick={handleCancelar}>
            No, cancelar
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
